export const REQUEST_USER = "REQUEST_USER";
export const RECEIVE_USER = "RECEIVE_USER";

const requestUser = () => ({ type: REQUEST_USER });
const receiveUser = (data) => ({ type: RECEIVE_USER, data });

export const fetchUser = () => {
  return async (dispatch) => {
    dispatch(requestUser());

    const response = await fetch("/api/users/self", {
      credentials: "include",
    });

    if (response.ok) {
      const user = await response.json();

      dispatch(receiveUser(user));
    }
  };
};
